/**
 * TanStack Query hooks for `loading-states-skeletons`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	loadingStatesSkeletonsQueryKeys,
	type CreateLoadingStatesSkeletonsBody,
	type ListLoadingStatesSkeletonsResponse,
	type LoadingStatesSkeletonsRow,
} from "./api";

export function useLoadingStatesSkeletonsList(): UseQueryResult<ListLoadingStatesSkeletonsResponse, Error> {
	return useQuery({
		queryKey: loadingStatesSkeletonsQueryKeys.list(),
		queryFn: list,
	});
}

export function useLoadingStatesSkeletonsCreate(): UseMutationResult<LoadingStatesSkeletonsRow, Error, CreateLoadingStatesSkeletonsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: loadingStatesSkeletonsQueryKeys.all });
		},
	});
}

export function useLoadingStatesSkeletonsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: loadingStatesSkeletonsQueryKeys.all });
		},
	});
}
